// Barrel export for all OBS feature card images
export { default as browserBasedZeroSetup } from './browserBasedZeroSetup.png';
export { default as complexInstallAndSetup } from './complexInstallAndSetup.png';
export { default as easyGuestManagement } from './easyGuestManagement.png';
export { default as noNativeGuestSupport } from './noNativeGuestSupport.png';
export { default as oneStreamMultipleDestinations } from './oneStreamMultipleDestinations.png';
export { default as addOnsForMultistreaming } from './addOnsForMultistreaming.png';
